module.exports = __webpack_public_path__ + "static/media/course.4e92f242.png";